export default __webpack_public_path__ + "static/media/cat01_sit_8fps.937ffa84.gif";